import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from './product';

@Injectable({
  providedIn: 'root'
})
export class ProductRegistrationService {
  
  constructor(private http:HttpClient) { }
  public doProductRegistration(product:Product) {
    
    return this.http.post("http://localhost:8080/createProduct", product, {responseType: 'text' as 'json'});
  }
  // public productData(): Observable<any>
  // {
  //  //return this.http.get(`${this.url}`);
  //  return this.http.get("http://localhost:8080/getAllProducts");
  // }
  productData()
  {
   //return this.http.get(`${this.url}`);
   return this.http.get("http://localhost:8080/getAllProducts");
  }
  deleteAllProducts() {
    return this.http.get("http://localhost:8080/deleteAllProducts",{ responseType: 'text' as 'json'});
  }
  findbyName(name: String){
    return this.http.get("http://localhost:8080/getProduct?name="+name);
  }
  deletebyName(name: String){
    return this.http.get("http://localhost:8080/deleteProduct?name="+name);
  }
  
}
